import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { environment } from '../../../environments/environment';
import { LesseeService } from '../../services/lessee.service';

declare var Stripe: any;

@Component({
  selector: 'app-lessee-payment',
  templateUrl: './lessee-payment.component.html',
  styleUrls: ['./lessee-payment.component.scss']
})
export class LesseePaymentComponent implements OnInit {
  paymentLoading = false;
  stripe;

  cardNumber;
  cardExpiry;
  cardCvc;
  postalCode;

  cardNumberError = true;
  cardExpiryError = true;
  cardCvcError = true;
  postalCodeError = true;

  errorMessage;
  hasError = false;

  paymentAmount;
  customPaymentAmount;

  constructor(private lesseeService: LesseeService, public dialogRef: MatDialogRef<LesseePaymentComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { 
    this.paymentAmount = this.data.accountSummary.balanceDue;
  }

  ngOnInit() {
    setTimeout(() => {
      this.stripe = Stripe(environment.STRIPE_PUBLIC_KEY);
      var elements = this.stripe.elements();
      
      var style = {
        base: {
          fontSize: '16px',
          lineHeight: '24px',
          color: '#777',
          '::placeholder': {
            color: '#bbb',
          },
        },
      };

      this.cardNumber = elements.create('cardNumber', {style: style});
      this.cardNumber.mount('#card-number');

      this.cardExpiry = elements.create('cardExpiry', {style: style});
      this.cardExpiry.mount('#expiration-date');

      this.cardCvc = elements.create('cardCvc', {style: style});
      this.cardCvc.mount('#cvv');

      this.postalCode = elements.create('postalCode', {style: style});
      this.postalCode.mount('#postal-code');

      this.cardNumber.addEventListener('change', (event) => {
        this.cardNumberError = !event.complete;
      });

      this.cardExpiry.addEventListener('change', (event) => {
        this.cardExpiryError = !event.complete;
      });

      this.cardCvc.addEventListener('change', (event) => {
        this.cardCvcError = !event.complete;
      });

      this.postalCode.addEventListener('change', (event) => {
        this.postalCodeError = !event.complete;
      });
    }, 300);
  }

  cancelAction() {
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }

  submitPaymentAction() {
    if(this.cardNumberError || this.cardExpiryError || this.cardCvcError || this.postalCodeError) {
      this.errorMessage = "Please complete all fields.";
      this.hasError = true;
    } else {
      this.paymentLoading = true;
      this.stripe.createToken(this.cardNumber).then((result) => {
        if(result.error) {
          if(result.error.type == "card_error" || result.error.type == "validation_error") {
            this.errorMessage = "There was an error using your credit card information. Please correct the payment information before resubmitting.";
          } else {
            this.errorMessage = "There was an unexpected error using your credit card information. Please try again later.";
          }
          
          this.hasError = true;
        } else {
          let amount = this.paymentAmount == "customPaymentAmount" ? this.customPaymentAmount : this.paymentAmount;
          let cardInfo = {
            method: "CreditCard",
            token: result.token.id,
            cardId: result.token.card.id,
            type: result.token.card.type,
            brand: result.token.card.brand,
            expMonth: result.token.card.exp_month,
            expYear: result.token.card.exp_year,
            last4: result.token.card.last4,
            amount: amount
          };

          this.lesseeService.createCardPayment(cardInfo).then((res) => {
            this.paymentLoading = false;
            this.dialogRef.close();
          }).catch((err) => {
            this.paymentLoading = false;
            this.errorMessage = err.error.message;
            this.hasError = true;
          });
        }
      })
    }
  }
}
